export function extrairMensagemErro(data, fallback = 'Ops, algo deu errado ao salvar. Tente novamente.') {
    if (!data) return fallback;
    if (typeof data === 'string') return data;

    if (data.errors && typeof data.errors === 'object') {
        const mensagens = Object.values(data.errors).flat().filter(Boolean);
        if (mensagens.length > 0) return mensagens.join(' ');
    }

    if (typeof data.title === 'string' && data.title) return data.title;

    return fallback;
}
